interface ComparisonRow {
  criterion: string;
  excel: string;
  powerbi: string;
}

interface ComparisonTableProps {
  rows: ComparisonRow[];
  columnLabels?: {
    criterion?: string;
    left?: string;
    right?: string;
  };
  highlightColumn?: "left" | "right" | "powerbi" | "excel";
  intro?: string;
}

/**
 * ComparisonTable
 *
 * Three-column "criterion · A · B" table used by `comparison.rows`-style
 * sections (Excel vs Power BI, Tableau vs Power BI, ...). The right column
 * is highlighted by default; pass `highlightColumn` to invert.
 */
export default function ComparisonTable({
  rows,
  columnLabels,
  highlightColumn = "right",
  intro,
}: ComparisonTableProps) {
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error("ComparisonTable: `rows` array is empty or invalid.");
  }

  const labels = {
    criterion: columnLabels?.criterion ?? "Kriterium",
    left: columnLabels?.left ?? "Status quo",
    right: columnLabels?.right ?? "Power BI",
  };

  const highlightRight =
    highlightColumn === "right" || highlightColumn === "powerbi";

  return (
    <div className="comparison">
      {intro ? <p className="comparison-intro">{intro}</p> : null}
      <div className="comparison-table-wrap">
        <table className="comparison-table">
          <thead>
            <tr>
              <th scope="col">{labels.criterion}</th>
              <th
                scope="col"
                className={highlightRight ? "" : "comparison-th-highlight"}
              >
                {labels.left}
              </th>
              <th
                scope="col"
                className={highlightRight ? "comparison-th-highlight" : ""}
              >
                {labels.right}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.criterion}>
                <th scope="row">{row.criterion}</th>
                <td className={highlightRight ? "" : "comparison-td-highlight"}>
                  {row.excel}
                </td>
                <td className={highlightRight ? "comparison-td-highlight" : ""}>
                  {row.powerbi}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
